export { usePageDataAdapter, PageSharedDataContext } from './usePageDataAdapter';
